module.exports = __webpack_public_path__ + "img/PayGate-Card-Brand-Logos.c3f52770.png";